<template>
    <div class="c-header">
        <div class="c-header__wrap">
            <div class="c-header__logo">
              <a href="/">
                  <img src="../assets/images/header/agp-logo-new.svg" alt="Auto Group Polska logo">
              </a>
            </div>

            <div class="c-header__brands">
              <div>
                <img src="../assets/images/header/vw.svg" alt="Volkswagen logo">
              </div>
              <div>
                <img src="../assets/images/header/audi.svg" alt="Audi logo">
              </div>
              <div>
                <img src="../assets/images/header/skoda.svg" alt="Skoda logo">
              </div>
              <div>
                <img src="../assets/images/header/seat.svg" alt="Seat logo">
              </div>
              <div>
                <img src="../assets/images/header/cupra.svg" alt="Cupra logo">
              </div>
              <div>
                <img src="../assets/images/header/vwd.svg" alt="Volkswagen dostawcze logo">
              </div>
            </div>

            <div class="c-header__social">
              <a href="https://www.facebook.com/AutoGroupPolska" target="_blank">
                <div class="c-header__social-item">
                  <img src="../assets/images/icons/facebook.svg" alt="Facebook">
                </div>
              </a>
              <a href="https://www.youtube.com/channel/UCiUkKY0j9ONBdsX9OkWuRiw/featured" target="_blank">
                <div class="c-header__social-item">
                  <img src="../assets/images/icons/youtube.svg" alt="Youtube">
                </div>
              </a>
              <a href="https://www.instagram.com/autogrouppolska/" target="_blank">
                <div class="c-header__social-item">
                  <img src="../assets/images/icons/instagram.svg" alt="Instagram">
                </div>
              </a>
              <a href="https://www.linkedin.com/company/auto-group-polska/mycompany/?viewAsMember=true" target="_blank">
                <div class="c-header__social-item">
                  <img src="../assets/images/icons/linkedin.svg" alt="Linkedin">
                </div>
              </a>
            </div>
        </div>
    </div>
</template>
<script>
export default {

}
</script>
<style lang="scss">
    .c-header{
        &__wrap{
            display: flex;
            align-items: center;
            justify-content: space-between;
            max-width: 1640px;
            padding:2rem 1rem;
            margin: 0 auto;
            @media (max-width:1640px) {
                max-width: 1430px;
            }
            @media (max-width:1430px) {
                // max-width: 1124px;
            }
            @media(max-width:768px){
              display: block;
            }
        }
        &__logo{
          img{
            max-width: 100%;
          }
        }
        &__social{
          box-shadow: 3px 3px 6px rgba(0,0,0,0.16);
          display: inline-flex;
          align-items: center;
          @media(max-width:768px){
            margin-top:20px;
          }
          &-item{
            width: 55px;
            height: 55px;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            &:hover{
              border:2px solid #000000;
            }
          }
        }
        &__brands{
          display: flex;
          align-items: center;
          @media(max-width: 1200px){
            flex-wrap: wrap;
            max-width: 250px;
          }
          @media(max-width: 960px){
            display: none;
          }
          img{
            margin:0 10px;
            @media(max-width: 1200px){
              margin:5px 10px;
            }
          }
        }
    }
</style>
